import { render, staticRenderFns } from "./MapHighlight.vue?vue&type=template&id=56628b3b"
import script from "./MapHighlight.vue?vue&type=script&lang=js"
export * from "./MapHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports